import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import Eye from "../../assets/images/icons/Eye.svg";

import { useNavigate } from "react-router-dom";
import { formatEventDate } from "../../utils/formatEventDate";
import PassDetailsModal from "./PassDetailsModal";
import { toastErrorMessage } from "../../utils/utils";
import { FaRegClock } from "react-icons/fa";
import { HiOutlineLocationMarker } from "react-icons/hi";
const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";

function EventTicketCard({ event }) {
  const [showPassModal, setShowPassModal] = useState(false);

  const handleDownloadPDF = async (pdf_path) => {
    if (!pdf_path) {
      toastErrorMessage("Ticket PDF is not available");
      return;
    }
    const fileURL = `${IMAGE_BASEURL}${pdf_path}`;
    try {
      const response = await fetch(fileURL);
      if (!response.ok) {
        toastErrorMessage("Ticket PDF is not available");
        return;
      }
      const blob = await response.blob();
      const blobURL = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobURL;
      const filename = pdf_path.split("/").pop() || "ticket.pdf";
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobURL);
    } catch (error) {
      console.error("PDF download error:", error);
      toastErrorMessage("Ticket PDF is not available");
    }
  };

  console.log(event);

  return (
    <>
      <Card className="mb-3 event-ticket-card-list">
        <Card.Body className="d-flex gap-3 align-items-center event-ticket-card">
          <div className="d-flex event-ticket-left">
            {/* Event Image */}
            <img
              src={`${IMAGE_BASEURL}${event?.image_path}`}
              alt={event?.title}
              style={{
                width: 148,
                height: 95,
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />

            <div className="ms-sm-3 ms-0 mt-3 mt-sm-0 ">
              <h2 className="mb-1 f-18 text-main fw-bold event-list-heading">
                {event?.title}
              </h2>

              <div className="event-list-desc">
                <div className="d-flex my-1">
                  <div className="me-2 listing-icons">
                    <FaRegClock />
                  </div>
                  <p className="mb-0"> {formatEventDate(event)}</p>
                </div>
                <div className="d-flex">
                  <div className="me-2 listing-icons">
                    <HiOutlineLocationMarker />
                  </div>
                  <p className="mb-0">{event?.venue}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="me-sm-4 ms-sm-auto me-0 event-ticket-right">
            {/* Tickets Count */}
            <button className="light-orange-bg btn btn-orange px-3 py-1 me-4 ticket-btn">
              {event?.ticketsCount} Tickets
            </button>

            {/* View Icon */}
            <img
              src={Eye}
              alt="eye "
              size={22}
              className="text-secondary"
              style={{ cursor: "pointer" }}
              onClick={() => setShowPassModal(true)}
            />
          </div>
        </Card.Body>
      </Card>

      <PassDetailsModal
        show={showPassModal}
        onHide={() => setShowPassModal(false)}
        event={event}
        tickets={event?.tickets || []}
        onDownload={handleDownloadPDF}
      />
    </>
  );
}

export default EventTicketCard;
